export default __webpack_public_path__ + "static/media/1872-00_7.6b2c253d.jpg";